import React, { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import api from "../api";

export default function Announcements() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/announcements").then((r) => setRows(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-4">
      {rows.map((a) => (
        <div key={a.id} className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm md:p-6">
          <div className="flex items-start gap-4">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-violet-100">
              <Megaphone className="h-5 w-5 text-violet-600" />
            </div>
            <div className="flex-1">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <h3 className="text-base font-bold text-slate-900">{a.title}</h3>
                <span className="text-xs text-slate-400">{a.date}</span>
              </div>
              <p className="mt-1 text-sm text-slate-500">{a.body}</p>
            </div>
          </div>
        </div>
      ))}
      {rows.length === 0 && <div className="text-sm text-slate-400">No announcements yet.</div>}
    </div>
  );
}
